













































import { Component, Prop, Vue } from "vue-property-decorator";

import { CookieHelper } from "@/helper/cookieHelper";
import { DateHelper } from "@/helper/dateHelper";
import { CloudHelper } from "@/helper/cloudHelper";
import { ResourceHelper } from "@/helper/resourceHelper";
import { Const } from "@/const";
import platform from '@/helper/platform';

import Close from "../resources/close.vue";
import DisplayPassword from "../resources/displayPassword.vue";

@Component({
  components: {
      Close,
      DisplayPassword
  }
})

export default class SignInScreen extends Vue {
    @Prop() private isError! : boolean;
    @Prop() private errorMessages! : Array<{index : number, message: string}>;

    mail = "";
    password = "";
    isLook = false;
    isCanSubmit = false;

    private mounted(){
        (this.$refs.mail as HTMLElement).focus();
    }

    private onDoCommand(command : string, param : any){
        this.$emit("doCommand", command, param);
    }

    private setCanSubmit(){
        this.isCanSubmit = true;
    }

    private keyupEnter(element){
        if(!this.isCanSubmit){ return; }
        this.isCanSubmit = false;
        (this.$refs[element] as HTMLElement).blur();
        if(this.mail == "" || this.password == ""){ return; }
        this.signIn();
    }

    private returnPage(){
        this.onDoCommand("returnPage", null);
    }

    private signIn(){
        var param = {
            mail: this.mail,
            password: this.password,
            installId : CookieHelper.getItem("installId"),
            platformId : String(platform.id),
            accessToken : CookieHelper.hasItem("accessToken") ? CookieHelper.getItem("accessToken") : null,
            refreshToken : CookieHelper.hasItem("refreshToken") ? CookieHelper.getItem("refreshToken") : null
        };
        this.onDoCommand("signIn", param);
    }

    private createAccount(){
        this.onDoCommand("createAccount", null);
    }

    private forgotPassword(){
        this.onDoCommand("forgotPassword", null);
    }

    private get changeLook(){
        return this.isLook ? "text" : "password";
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigButtonColor(){
        var style = {
            backgroundColor: this.userConfigColor
        };
        return style;
    }
    private get userConfigUnderLineColor(){
        var style = {
            borderBottom: "solid 1px " + this.userConfigColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
